import React from 'react';
import reactDOM from 'react-dom';
import App from './App';

reactDOM.render(<App />, window.document.getElementById('root'));
